import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions, cocktailActions } from '../_actions';
import { DeleteButton } from '../DeleteButton';
import { Ingredient } from '../Ingredient';

class Ingredients extends React.Component {
  componentDidMount() {
    this.props.dispatch(cocktailActions.getAllIngredients());
  }

  render() {
    const {user, ingredients} = this.props;

    return (
      <div>
      <div class="row">
        <div className="col-sm-4 col-md-offset-2">
        <h2>Ingredient List Page</h2>
          {user.access_level > 5 &&
          <Link to="/add_ingredient" className="btn btn-link">Add Ingredient</Link>
          }

        {ingredients.loading && <em>Loading ingredients...</em>}
        {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
        {ingredients.items &&
          <div>
            <ol>
              {ingredients.items.map((thisIngredient, index) =>
                <li value={thisIngredient.cocktail_ct} key={thisIngredient.machine_name}>
                  <Link to={`/ingredient/${thisIngredient.machine_name}`}>{thisIngredient.name}</Link>
                  <DeleteButton item={thisIngredient} user={user} collection={'ingredients'}/>
                </li>
              )}
            </ol>

          </div>
        }
        </div>
        <div className="col-sm-4">
          <div className="container-fluid">
            <Route path={`/ingredient/:machine_name`} render={({ match })=><div class="card-columns"><Ingredient match={match} ingredients={ingredients} showEdit={true}/></div>} />
            <Route exact path="/ingredient" render={() => <h3>Please select an ingredient.</h3>} />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          {ingredients.loading && <em>Loading ingredients...</em>}
          {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
          {ingredients.items &&
          <div class="card-columns">
            {ingredients.items.map((thisIngredient, index) =>
              <Link to={`/ingredient/${thisIngredient.machine_name}`}>
                <div class="card">
                  <Ingredient key={thisIngredient.machine_name} match={thisIngredient.machine_name} ingredients={ingredients} showCabinetRemove={false}/>
                </div>
              </Link>
            )
            }
          </div>
          }
        </div>
      </div>
      </div>

    );
  }
}

const IngredientDelete = ({ match, ingredients }) => {

  const machine_name = match.params.topicId

  const isIngredient = p => p.machine_name === machine_name
  let ingredient = ''
  if (ingredients.items) {
    ingredient = ingredients.items.find(isIngredient)


    if (!ingredient) {
      return <div>Sorry, but the ingredient was not found</div>
    }
    return (
      <div id="parent">
        <div>
          <h1 id={ingredient.machine_name}>{ingredient.name}</h1>
          <Link to={`/ingredient/${ingredient.machine_name}/edit`} className="btn btn-link">Edit</Link>
          <h2>Container:</h2>
          <div dangerouslySetInnerHTML={{__html: ingredient.container}}/>
          <div>{ingredient.category}</div>
          <img src={ingredient.img_url}/>
        </div>
      </div>
    )
  } else {
    return <div>Select an ingredient from the left to continue.</div>
  }

}

function mapStateToProps(state) {
    const { ingredients, authentication } = state;
    const { user } = authentication;
    return {
        user,
      ingredients
    };
}

const connectedIngredients = connect(mapStateToProps)(Ingredients);
export { connectedIngredients as Ingredients };


// WEBPACK FOOTER //
// ./src/Ingredients/Ingredients.jsx